import { type SettingsState } from 'app/store/fuse/settingsSlice';
// import themesConfig from './themesConfig';
import i18n from '../../i18n';

const settingsConfig: SettingsState = {
	layout: {
		style: 'layout1',
		config: {}
	},
	customScrollbars: false,
	direction: i18n.dir(i18n.options.lng) || 'ltr',
	theme: {
		main: import.meta.env.VITE_DEFAULT_THEME,
		navbar: import.meta.env.VITE_DEFAULT_THEME,
		toolbar: import.meta.env.VITE_DEFAULT_THEME,
		footer: import.meta.env.VITE_DEFAULT_THEME
	},
	defaultAuth: undefined,
	loginRedirectUrl: '/summary'
};

export default settingsConfig;
